import React from 'react';
import { Card } from 'components/ui/card';
import { Button } from 'components/ui/button';
import { CircleHelp } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';
import { Skeleton } from 'components/ui/skeleton';

const RetryButton = ({ query }) => (
  <Button variant="outline" size="sm" disabled={query.isFetching} onClick={() => query.refetch()}>
    Réessayer
  </Button>
);

const DashboardSection = ({ title, query, available, children, help, headerContent = null, className = '' }) => (
  <Card
    className={`min-w-0 rounded-[9px] border-[#e3e8e6] p-5 shadow-[0_1px_2px_rgba(18,43,30,0.01)] sm:p-[22px] ${className}`}
    aria-label={title}
  >
    <div className={`mb-[18px] ${headerContent ? 'flex flex-wrap items-center justify-between gap-x-6 gap-y-3' : ''}`}>
      <h2 className="flex items-center gap-1.5 text-base font-semibold leading-6">
        {title}
        {help && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                aria-label={`À propos de ${title}`}
                className="rounded-full text-slate-500 focus-visible:outline focus-visible:outline-2"
              >
                <CircleHelp className="h-4 w-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent>{help}</TooltipContent>
          </Tooltip>
        )}
      </h2>
      {headerContent}
    </div>
    {query.isLoading && !query.data ? (
      <div className="min-h-[160px] space-y-4 py-4" aria-label="Loading" role="status">
        <Skeleton className="h-10 w-2/5" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-4/5" />
      </div>
    ) : !available ? (
      <div className="space-y-3 py-8">
        <p role="alert" className="text-sm text-slate-600">
          Données indisponibles.
        </p>
        <RetryButton query={query} />
      </div>
    ) : (
      <>
        {query.isError && (
          <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
            <p role="alert" className="text-sm text-red-700">
              Actualisation impossible. Les dernières données reçues sont affichées.
            </p>
            <RetryButton query={query} />
          </div>
        )}
        {children}
      </>
    )}
  </Card>
);
export default DashboardSection;
